import WelcomeMessageFromMichael from "./WelcomeMessageFromMichael.mp3";

export default {
  WelcomeMessageFromMichael
};
